(() => {
  const root = document.querySelector('[data-am-product]');
  if (!root) return;

  const media = [...root.querySelectorAll('[data-am-media]')];
  const thumbs = [...root.querySelectorAll('[data-am-thumb]')];
  const showMedia = (id) => {
    media.forEach((item) => { item.hidden = item.dataset.amMedia !== String(id); item.classList.toggle('is-active', item.dataset.amMedia === String(id)); });
    thumbs.forEach((item) => { const active = item.dataset.amThumb === String(id); item.classList.toggle('is-active', active); item.toggleAttribute('aria-current', active); });
  };
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.amThumb)));

  const quantity = root.querySelector('[data-am-quantity]');
  if (quantity) {
    const input = quantity.querySelector('input');
    quantity.querySelector('[data-am-quantity-minus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
    quantity.querySelector('[data-am-quantity-plus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) + 1); });
  }

  const form = root.querySelector('[data-am-form]');
  if (form) {
    const variantId = form.querySelector('[data-am-variant-id]');
    const options = [...form.querySelectorAll('[data-am-option]')];
    const price = root.querySelector('[data-am-price]');
    const addButton = root.querySelector('[data-am-add]');
    const addLabel = root.querySelector('[data-am-add-label]');
    const productUrl = root.dataset.productUrl || window.location.pathname;
    const refreshVariant = async () => {
      const params = new URLSearchParams();
      options.filter((option) => option.checked).forEach((option) => params.append('option[]', option.value));
      const response = await fetch(`${productUrl}.js`);
      const product = await response.json();
      const selected = product.variants.find((variant) => variant.options.every((value, index) => value === params.getAll('option[]')[index])) || product.variants[0];
      variantId.value = selected.id;
      addButton.disabled = !selected.available;
      addLabel.textContent = selected.available ? addLabel.dataset.availableLabel || addLabel.textContent : addLabel.dataset.soldOutLabel || 'Sold out';
      const formatMoney = (cents) => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents, price.dataset.moneyFormat) : (cents / 100).toFixed(2);
      if (price) price.innerHTML = selected.compare_at_price > selected.price ? `<s>${formatMoney(selected.compare_at_price)}</s><span>${formatMoney(selected.price)}</span>` : `<span>${formatMoney(selected.price)}</span>`;
    };
    options.forEach((option) => option.addEventListener('change', refreshVariant));
  }

  const bundle = root.querySelector('[data-am-bundle]');
  bundle?.querySelector('[data-am-bundle-add]')?.addEventListener('click', async () => {
    const status = bundle.querySelector('[data-am-bundle-status]');
    const items = [...bundle.querySelectorAll('[data-am-bundle-item]:checked')].map((item) => ({ id: Number(item.value), quantity: 1 }));
    if (!items.length) { status.textContent = 'Select at least one item.'; return; }
    status.textContent = 'Adding selected items…';
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items }) });
    status.textContent = response.ok ? 'Added to cart.' : 'Unable to add items. Please try again.';
    if (response.ok) document.dispatchEvent(new CustomEvent('cart:refresh'));
  });
})();
